import * as Yup from "yup";
import {
  PASSWORD_REGEX_WITH_SPECIAL_CHARACTERS,
  WHITE_SPACES_REGEX,
  PASSWORD_MAX_LIMIT,
  PASSWORD_MIN_LIMIT,
} from "../constants";

export const changePasswordFieldNames = {
  CONFIRM_PASSWORD: "confirmPassword",
  PASSWORD: "password",
};

export const changePasswordInitialValues = {
  [changePasswordFieldNames.CONFIRM_PASSWORD]: "",
  [changePasswordFieldNames.PASSWORD]: "",
  [changePasswordFieldNames.OLD_PASSWORD]: "",
};

export const changePasswordValidationSchema = (intl) =>
  Yup.object().shape({
    [changePasswordFieldNames.PASSWORD]: Yup.string()
      .required(
        intl.formatMessage({ id: "login.fieldError.password.required" })
      )
      .matches(
        WHITE_SPACES_REGEX,
        intl.formatMessage({ id: "login.fieldError.password.invalid" })
      )
      .min(
        PASSWORD_MIN_LIMIT,
        intl.formatMessage({ id: "login.fieldError.password.min" })
      )
      .max(
        PASSWORD_MAX_LIMIT,
        intl.formatMessage({ id: "login.fieldError.password.max" })
      )
      .matches(
        PASSWORD_REGEX_WITH_SPECIAL_CHARACTERS,
        intl.formatMessage({ id: "login.fieldError.password.invalid" })
      ),
    [changePasswordFieldNames.CONFIRM_PASSWORD]: Yup.string()
      .required(
        intl.formatMessage({ id: "login.fieldError.password.required" })
      )
      .oneOf(
        [Yup.ref("password"), null],
        intl.formatMessage({ id: "login.passwordsDoNotMatch" })
      ),
  });
